import { render, staticRenderFns } from "./CmgMemberLoyaltyRewards.vue?vue&type=template&id=0aae71a6&scoped=true&lang=pug"
import script from "./cmg-member-loyalty-rewards.ts?vue&type=script&lang=ts&external"
export * from "./cmg-member-loyalty-rewards.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgMemberLoyaltyRewards.vue?vue&type=style&index=0&id=0aae71a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aae71a6",
  null
  
)

export default component.exports